export const childrenIncludesInAddedRemovedArr = (arr, val) => {
  const { parentName, childName, parentId, childrenId, childrenCount } = val;
  return childrenCount === 1
    ? arr.find(arrItem => arrItem[parentName] === parentId)
    : arr.find(arrItem => arrItem[parentName] === parentId)?.[childName].includes(childrenId);
};

export const parentIncludesInAddedRemovedArr = (arr, parentName, parentId) => {
  return parentName ? arr.find(arrItem => arrItem[parentName] === parentId) : arr.includes(parentId);
};

export const includesParentId = (prev, val) => {
  const { parentName, childName, optionId } = val;
  return parentName && childName ? prev.some(prevVal => prevVal?.[parentName] === optionId) : prev?.includes(optionId);
};

export const parentWithoutId = (prev, val) => {
  const { parentName, childName, optionId } = val;
  return prev?.filter(prevValue =>
    parentName && childName ? prevValue[parentName] !== optionId : prevValue !== optionId,
  );
};

export const putParent = (prev, val) => {
  const { parentName, childName, optionId } = val;
  return [...prev, parentName && childName ? { [parentName]: optionId, [childName]: [] } : optionId];
};

export const removedChildrenFromAddedRemoved = (prev, parentName, childName, parentId, childrenId) => {
  // eslint-disable-next-line unicorn/no-array-reduce
  const res = prev.reduce((result, prevVal) => {
    if (prevVal[parentName] === parentId && prevVal[childName].length > 1) {
      return [...result, { ...prevVal, [childName]: prevVal[childName].filter(prevChild => prevChild !== childrenId) }];
    } else if (prevVal[parentName] === parentId && prevVal[childName].length === 1) {
      return result;
    }
    return [...result, prevVal];
  }, []);

  return res;
};

export const removedParentFromAddedRemoved = (prev, value) => {
  const { parentName, optionId } = value;
  return prev.filter(val => (parentName ? val[parentName] !== optionId : val !== optionId));
};

export const setAddedRemovedArrChildren = (prev, val) => {
  const { childrenCount, checkChilds, parentName, childName, parentId, childrenId } = val;
  return prev.some(prevItem => prevItem[parentName] === parentId)
    ? prev.map(prevId => {
        return prevId[parentName] === parentId
          ? new Set([...(checkChilds || []), ...prevId[childName]]).size + 1 === childrenCount
            ? { ...prevId, [childName]: [] }
            : { ...prevId, [childName]: [...prevId[childName], childrenId] }
          : (prevId as { [key: string]: string }[]);
      })
    : [
        ...prev,
        {
          [parentName]: parentId,
          [childName]: childrenCount === 1 || +checkChilds?.length + 1 === childrenCount ? [] : [childrenId],
        },
      ];
};

export const checkChildrenWithBrothers = (prev, val) => {
  const { parentId, parentName, childName, brothersIds } = val;
  // eslint-disable-next-line unicorn/no-array-reduce
  const res = prev.reduce((result, prevVal) => {
    if (prevVal[parentName] === parentId && brothersIds.length > 0) {
      return [...result, { ...prevVal, [childName]: brothersIds }];
    } else if (prevVal[parentName] === parentId && brothersIds.length === 0) {
      return result;
    }
    return [...result, prevVal];
  }, []);

  return res;
};

export const changeIdsChildren = (prev, value) => {
  const { brothersIds, parentName, parentId, checked, allChecked, childName, childrenId } = value;
  const brothersIdsLength = brothersIds.length;

  const childrenCount = +brothersIds.length + 1;
  const lengthChild: number = prev.find(prevVal => prevVal[parentName] === parentId)?.[childName]?.length || 0;

  const resetCond = (!checked && !allChecked) || (checked && allChecked);

  if (lengthChild && lengthChild + 1 === childrenCount) {
    return setAddedRemovedArrChildren(prev, { ...value, childrenCount });
  } else if (lengthChild === 0 && resetCond) {
    return brothersIdsLength > 0
      ? prev.map(prevId =>
          prevId[parentName] === parentId
            ? {
                ...prevId,
                [childName]: brothersIds,
              }
            : prevId,
        )
      : prev.filter(prevVal => prevVal[parentName] !== parentId);
  } else if (lengthChild === 1 && resetCond) {
    return prev.filter(prevVal => prevVal[parentName] !== parentId);
  } else if (prev.some(prevItem => prevItem[parentName] === parentId)) {
    return prev.map(prevId =>
      prevId[parentName] === parentId
        ? {
            ...prevId,
            [childName]:
              +prevId[childName].length + 1 === childrenCount
                ? []
                : prevId[childName].includes(childrenId)
                ? prevId[childName].filter(prevChild => prevChild !== childrenId)
                : [...prevId[childName], childrenId],
          }
        : (prevId as { [key: string]: string }[]),
    );
  } else
    return [
      ...prev,
      {
        [parentName]: parentId,
        [childName]: childrenCount === 1 ? [] : [childrenId],
      },
    ];
};
